import React from 'react';
import { ESIM_PLANS } from '../mock';
import { Button } from '../components/ui/button';
import { useCart } from '../context/CartContext';
import { useNavigate } from 'react-router-dom';
import { useToast } from '../hooks/use-toast';
import { Wifi, Globe, Zap } from 'lucide-react';

const ESim = () => {
  const { addItem } = useCart();
  const { toast } = useToast();
  const navigate = useNavigate();

  const handleBuy = (plan) => {
    addItem({
      brandId: plan.id, brandName: `eSIM · ${plan.country}`, brandLogo: 'https://logo.clearbit.com/airalo.com', brandColor: '#8247E5',
      denomination: plan.price, country: `${plan.data} / ${plan.days}d`, quantity: 1,
    });
    toast({ title: 'eSIM added to cart' });
    navigate('/checkout');
  };

  return (
    <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
      <div className="grid md:grid-cols-2 gap-8 items-center mb-10">
        <div>
          <div className="inline-block px-3 py-1 rounded-full bg-violet-100 text-[#8247E5] text-xs font-semibold mb-3">TRAVEL WITH CRYPTO</div>
          <h1 className="font-display text-3xl md:text-4xl font-bold">Global eSIMs, paid with Bitcoin</h1>
          <p className="text-neutral-600 mt-3">Get instant mobile data in 130+ countries. Delivered to your phone as a QR code within minutes of your payment.</p>
          <div className="mt-5 space-y-2 text-sm">
            <div className="flex items-center gap-2"><Zap className="w-4 h-4 text-[#8247E5]" /> Activates in under 5 minutes</div>
            <div className="flex items-center gap-2"><Globe className="w-4 h-4 text-[#8247E5]" /> 130+ countries and regions</div>
            <div className="flex items-center gap-2"><Wifi className="w-4 h-4 text-[#8247E5]" /> Works with iPhone XS+ and modern Android</div>
          </div>
        </div>
        <div className="bg-gradient-to-br from-violet-50 to-fuchsia-50 rounded-2xl border border-violet-100 p-8 text-center">
          <div className="font-display text-6xl">🌐</div>
          <div className="mt-4 font-semibold text-neutral-900">Anywhere in the world, no roaming fees.</div>
        </div>
      </div>

      <h2 className="font-display text-2xl font-bold mb-4">Popular plans</h2>
      <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-4">
        {ESIM_PLANS.map(plan => (
          <div key={plan.id} className="bg-white rounded-2xl border border-neutral-200 p-6 hover:border-[#8247E5] transition-colors">
            <div className="flex items-start justify-between">
              <div>
                <div className="text-3xl">{plan.flag}</div>
                <div className="font-semibold mt-2">{plan.country}</div>
              </div>
              <div className="text-right">
                <div className="font-display text-2xl font-bold">${plan.price}</div>
                <div className="text-xs text-neutral-500">USD</div>
              </div>
            </div>
            <div className="mt-4 flex gap-3 text-sm text-neutral-700">
              <div className="bg-neutral-100 rounded-lg px-2.5 py-1 font-semibold">{plan.data}</div>
              <div className="bg-neutral-100 rounded-lg px-2.5 py-1">{plan.days} days</div>
            </div>
            <Button onClick={() => handleBuy(plan)} className="w-full mt-5 h-11 bg-[#8247E5] hover:bg-[#6d33cc] text-white font-semibold">
              Buy with crypto
            </Button>
          </div>
        ))}
      </div>
    </div>
  );
};

export default ESim;
